const DISCLAIMER_TEXT_PAR1 = `I, Licensee, have obtained the legally required and appropriate patient photo or video talent release by
the patient and/or guardian for use in the OrthoCatapult™ system. I verify that the authorization allows for
unrestricted use of the patient’s likeness, image, voice, appearance, and performance in the system.`;

const DISCLAIMER_TEXT_PAR2 = `Licensee understands that Licensor, Practice Catapult LLC, has no liability to Licensee or any other third
party where Licensee has failed to obtain the appropriate patient photo or video talent release
authorization and documentation for use within the system. Licensee understands that at no time shall
Licensor be considered a party to any contract or agreement made between Licensee and any third party
and in no way shall such a contract or agreement be in any way binding upon Licensor.`;

const DISCLAIMER_AGREED = `I agree to the above and the full`;

const LICENSE_LINK = `Terms of Licensee Content Use.`;

const LICENSEE_CONTENT_PAR1 = `When Licensee uses the system, Licensee provides Licensor with things such as files, content, messages, contacts and so on
("Licensee Content"). Licensee Content is Licensee’s. These Terms don't give Licensor any rights to Licensee Content except for the
limited rights that enable Licensor to offer the services of the system.`;

const LICENSEE_CONTENT_PAR2 = `Licensor needs Licensee’s permission to do things like hosting Licensee Content, backing it up, and sharing it when Licensee ask
Licensor to. Licensor’s services also provide Licensee with features like photo thumbnails, document previews, commenting, easy
sorting, editing, sharing and searching. These and other features may require the system to access, store and scan Licensee Content.
Licensee gives Licensor permission to do those things, and this permission extends to Licensor’s affiliates and trusted third parties
Licensor works with.`;

const PATIENT_GUARDIAN_TALENT_RELASES_PAR1 = `Licensee has obtained all the legally required and appropriate patient photo or video talent releases by the patients and/or guardians for
use in the system. Licensee verifies that the authorization allows for unrestricted use of the patient’s likeness, image, voice,
appearance, and performance in the system.`;

const PATIENT_GUARDIAN_TALENT_RELASES_PAR2 = `Licensee understands that Licensor has no liability to Licensee or any other third party where Licensee has failed to obtain the
appropriate patient photo or video talent release authorization and documentation for use within the system. Licensee understands that
at no time shall Licensor be considered a party to any contract or agreement made between Licensee and any third party and in no way
shall such a contract or agreement be in any way binding upon Licensor.`;

const SHARING_LICENSE_CONTENT_PAR1 = `The system lets Licensee share Licensee Content with others. Licensee is fully responsible for any Licensee Content shared.`;

const LICENSEE_CONTENT_RESPONSIBILIIES_PAR1 = `Licensee is responsible for their conduct. Licensee Content and Licensee must comply with Licensor’s Acceptable Use Policy.
Content in the system may be protected by others' intellectual property rights. Licensee will not copy, upload, download or share
content unless Licensee has the right to do so. For all patient images, videos, likeness, voices, appearances and performances Licensee
uploads, Licensee verifies they have obtained all the patient and/or guardian talent releases required by law for utilization in the
system.`;

const LICENSEE_CONTENT_RESPONSIBILIIES_PAR2 = `Licensor may review Licensee’s conduct and content for compliance with these Terms of Content Use and Licensor’s Acceptable Use
Policy. However, Licensor has no obligation to do so. Licensor aren't responsible for the content Licensee enters and shares via the
system.`;

const LICENSEE_CONTENT_RESPONSIBILIIES_PAR3 = `Licensee will safeguard their password to the system, and keep their account information current. Licensee will not share their account
credentials or give others access to their account.`;

const LICENSEE_CONTENT_RESPONSIBILIIES_PAR4 = `Licensee may use the system only as permitted by applicable law, including export control laws and regulations. Finally, the system is
not intended for and may not be used by people under the age of 18. By using the system, Licensee is representing to Licensor that
they are over 18.`;

const LICENSORS_CONTENT_PAR1 = `The system is protected by copyright, trademark, and other US and foreign laws. These Terms do not grant Licensee any right, title or
interest in the system, others' content in the system, Practice Cataplut LLC & OrthoCatapult™ trademarks, logos and other brand
features. Licensor welcomes feedback, but note that we may use comments or suggestions without any obligation to Licensees.`;

const COPYRIGHT_CONTENT_PAR1 = `Licensor respects the intellectual property of others and ask that Licensee does too. Licensor responds to notices of alleged copyright
infringement if they comply with the law, and such notices should be reported using our Copyright Policy. Licensor reserves the right
to delete or disable content alleged to be infringing and terminate accounts of repeat infringers. Our designated agent for notice of
alleged copyright infringement on the system is:`;

export const Contract = {
    DISCLAIMER_TEXT_PAR1: DISCLAIMER_TEXT_PAR1,
    DISCLAIMER_TEXT_PAR2: DISCLAIMER_TEXT_PAR2,
    DISCLAIMER_AGREED: DISCLAIMER_AGREED,
    LICENSEE_CONTENT_PAR1: LICENSEE_CONTENT_PAR1,
    LICENSEE_CONTENT_PAR2: LICENSEE_CONTENT_PAR2,
    PATIENT_GUARDIAN_TALENT_RELASES_PAR1: PATIENT_GUARDIAN_TALENT_RELASES_PAR1,
    PATIENT_GUARDIAN_TALENT_RELASES_PAR2: PATIENT_GUARDIAN_TALENT_RELASES_PAR2,
    SHARING_LICENSE_CONTENT_PAR1: SHARING_LICENSE_CONTENT_PAR1,
    LICENSEE_CONTENT_RESPONSIBILIIES_PAR1: LICENSEE_CONTENT_RESPONSIBILIIES_PAR1,
    LICENSEE_CONTENT_RESPONSIBILIIES_PAR2: LICENSEE_CONTENT_RESPONSIBILIIES_PAR2,
    LICENSEE_CONTENT_RESPONSIBILIIES_PAR3: LICENSEE_CONTENT_RESPONSIBILIIES_PAR3,
    LICENSEE_CONTENT_RESPONSIBILIIES_PAR4: LICENSEE_CONTENT_RESPONSIBILIIES_PAR4,
    LICENSORS_CONTENT_PAR1: LICENSORS_CONTENT_PAR1,
    COPYRIGHT_CONTENT_PAR1: COPYRIGHT_CONTENT_PAR1,
    LICENSE_LINK: LICENSE_LINK
}
